import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PricingRuleForm from './widgets/PricingRuleForm';

export default function EditPricingRuleScreen() {
  const { id } = useParams();
  const location = useLocation();
  const returnTo = location.state?.returnTo || null;
  return <PricingRuleForm mode="edit" ruleId={id} returnTo={returnTo} />;
}
